import React, { Component } from 'react';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
	level: number;
	hideOverfow: boolean;
	title?: string;
}

export default class Heading extends Component<Props> {
	static defaultProps = {
		level: 1,
		hideOverfow: false,
	};

	render() {
		const { children, level, hideOverfow, ...props } = this.props;
		const className = `level-${level}${hideOverfow ? '-hidden-overflow' : ''}` as keyof (typeof styles)['locals'];

		return (
			<h1 {...props} className={styles[className]}>
				{children}
			</h1>
		);
	}
}
